import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles(theme => ({
  root: {
    '& th': {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      position: 'sticky',
      zIndex: 99,
      top: 0,
      height: '35px',
      width: 'auto',
      '& span': {
        paddingLeft: '5px',
      }
    },
    '& th.fixedCol': {
      position: 'sticky',
      zIndex:100,
    },

    '& .pos': {
        left: 0,
    },
    '& .name': {
        left: 40,
    },
  },
}));


export const TableHeader: React.FC = () => {
  const classes = useStyles();

  return (
    <thead>
       <tr className={classes.root}>
    {/* <th>
        <span>Entry ID</span>
    </th> */}
    <th>
        <span>Name</span>
    </th>
    {/* <th>
        <span>Address</span>
    </th> */}
    <th>
        <span>Email</span>
    </th>
    <th>
        <span>Staus</span>
    </th>
    <th>
        <span>Phone No</span>
    </th>
    <th>
        <span>Date of Birth</span>
    </th>
    <th>
        <span>Gender</span>
    </th>
    <th>
        <span>Preferred Language</span>
    </th>
    {/* <th>
        <span>Previous Employer 1</span>
    </th>
    <th>
        <span>Previous Employer 1 Address</span>
    </th>
    <th>
        <span>Experience at Previous Employer 1</span>
    </th>
    <th>
        <span>Type of Work at Previous Employer 1</span>
    </th>
    <th>
        <span>Previous Employer 2</span>
    </th>
    <th>
        <span>Previous Employer 2 Address</span>
    </th>
    <th>
        <span>Experience at Previous Employer 2</span>
    </th>
    <th>
        <span>Type of Work at Previous Employer 2</span>
    </th> */}
    <th>
        <span>Jobs Interested In</span>
    </th>
    <th>
        <span>Preferred Location</span>
    </th>
    <th>
        <span>Profile</span>
    </th>
    <th>
        <span>ID Card</span>
    </th>
    <th>
        <span>CV</span>
    </th>
    <th>
        <span>Created at</span>
    </th>
</tr>
    </thead>
  );

};
